import React, { createContext, ReactNode, useContext } from "react";
// import useBreakpoint, { Breakpoint } from "../hooks/useBreakpoint";

// ==================================================
// Hook
// ==================================================

import { useState, useEffect } from "react";

const breakPoints = {
  mb: { name: "mb", res: 240, id: 0 },
  xs: { name: "xs", res: 360, id: 1 },
  sm: { name: "sm", res: 640, id: 2 },
  md: { name: "md", res: 768, id: 3 },
  lg: { name: "lg", res: 1024, id: 4 },
  xl: { name: "xl", res: 1280, id: 5 },
  "2xl": { name: "2xl", res: 1536, id: 6 },
};

export type Breakpoint = {
  name: string;
  res: number;
  id: number;
};

const getBreakpoint = (width: number): Breakpoint => {
  if (width >= breakPoints["2xl"].res) return breakPoints["2xl"];
  if (width >= breakPoints.xl.res) return breakPoints.xl;
  if (width >= breakPoints.lg.res) return breakPoints.lg;
  if (width >= breakPoints.md.res) return breakPoints.md;
  if (width >= breakPoints.sm.res) return breakPoints.sm;
  if (width >= breakPoints.xs.res) return breakPoints.xs;
  return breakPoints.mb;
};

const useBreakpoint = (): Breakpoint => {
  const innerWidth = typeof window !== "undefined" ? window.innerWidth : 0;
  const [breakpoint, setBreakpoint] = useState<Breakpoint>(() =>
    getBreakpoint(innerWidth)
  );

  useEffect(() => {
    const handleResize = () => {
      if (typeof window !== "undefined") {
        const currentBreakpoint = getBreakpoint(window.innerWidth);
        setBreakpoint(currentBreakpoint);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return breakpoint;
};

export default useBreakpoint;

// ==================================================
// Provider
// ==================================================

type BreakpointContextType = {
  breakpoint: Breakpoint;
};

const BreakpointContext = createContext<BreakpointContextType | undefined>(
  undefined
);

export const BreakpointProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const breakpoint = useBreakpoint();

  return (
    <BreakpointContext.Provider value={{ breakpoint }}>
      {children}
    </BreakpointContext.Provider>
  );
};

export const useBreakpointContext = (): BreakpointContextType => {
  const context = useContext(BreakpointContext);
  if (!context) {
    throw new Error(
      "useBreakpointContext must be used within a BreakpointProvider"
    );
  }
  return context;
};
